import React from 'react';
import { ArrowRight, Play } from 'lucide-react';
import { styles } from '../../styles/globalStyles';
import { platformPillars, keyFeatures, useCases } from '../../data/contentData';

export const PlatformSection = () => (
  <section style={styles.section}>
    <div style={styles.sectionContent}>
      <h2 style={styles.sectionTitle}>
        The Foundation for Enterprise AI Operations
      </h2>
      <p style={styles.sectionSubtitle}>
        Four core components that enable organizations to deploy autonomous AI agents 
        and connect them directly to business-critical operations.
      </p>
      
      <div style={styles.pillarsGrid}>
        {platformPillars.map((pillar, index) => (
          <div key={index} style={styles.pillarCard}>
            <div style={styles.pillarIcon}>
              {pillar.icon}
            </div>
            <h3 style={styles.pillarTitle}>{pillar.title}</h3>
            <p style={styles.pillarDescription}>{pillar.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const KeyFeaturesSection = () => (
  <section style={styles.section}>
    <div style={styles.sectionContent}>
      <h2 style={styles.sectionTitle}>
        Enterprise-Grade AI Agent Capabilities
      </h2>
      <p style={styles.sectionSubtitle}>
        Built for the world's most demanding environments where security, 
        reliability, and operational excellence are non-negotiable.
      </p>
      
      <div style={styles.keyFeaturesGrid}>
        {keyFeatures.map((feature, index) => (
          <div key={index} style={styles.featureCard}>
            <h3 style={styles.featureTitle}>
              {feature.icon}
              {feature.title}
            </h3>
            <p style={styles.featureDescription}>{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const UseCasesSection = () => (
  <section id="use-cases" style={styles.section}>
    <div style={styles.sectionContent}>
      <h2 style={styles.sectionTitle}>
        Proven in Mission-Critical Operations
      </h2>
      <p style={styles.sectionSubtitle}>
        From Fortune 500 companies to government agencies, organizations worldwide 
        depend on our platform to deploy AI agents that drive operational results.
      </p>
      
      <div style={styles.useCasesGrid}>
        {useCases.map((useCase, index) => (
          <div key={index} style={styles.useCaseCard}>
            <div style={styles.useCaseIndustry}>{useCase.industry}</div>
            <h3 style={styles.useCaseTitle}>{useCase.title}</h3>
            <p style={styles.useCaseDescription}>{useCase.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const FinalCTASection = () => (
  <section style={styles.section}>
    <div style={styles.sectionContent}>
      <div style={styles.finalCta}>
        <h2 style={styles.finalCtaTitle}>
          Ready to Deploy AI Agents in Your Enterprise?
        </h2>
        <p style={styles.finalCtaSubtitle}>
          Join leading organizations that trust Agent Development Platform 
          for their most critical AI operations.
        </p>
        <div style={styles.buttonGroup}>
          <button style={styles.ctaButton}>
            <span>Request Demo</span>
            <ArrowRight size={16} />
          </button>
          <button style={styles.secondaryButton}>
            <Play size={16} />
            <span>Watch Overview</span>
          </button>
        </div>
      </div>
    </div>
  </section>
);